import { Component, OnInit } from '@angular/core';
import { UserService } from '@service/user/user.service';
import { User } from '@model/user/user';
import { ScrollService } from '@service/scroll.service';
import { ProfileStateComponent } from '@component/profile/profile-state.component';
import { MobileService } from '@service/mobile.service';
import { LoadingService } from '@service/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { filter, Observable } from 'rxjs';
import { SliderImagesService } from '@service/slider-images.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent extends ProfileStateComponent implements OnInit {
  public user$: Observable<User>;

  public hasSliderImages: boolean = false;

  constructor(
    private userService: UserService,
    protected scrollService: ScrollService,
    public MobileService: MobileService,
    private LoadingService: LoadingService,
    protected MatDialog: MatDialog,
    public sliderImagesService: SliderImagesService,
  ) {
    super(scrollService);

    this.user$ = this.userService.userObservable.pipe(filter((user) => Boolean(user)));
  }

  ngOnInit() {
    super.ngOnInit();

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    });

    this.sliderImagesService.checkHasSliderImages('company');
  }

  public newCompanyProfile(type: 'CARPENTER' | 'CARPENTER_PLUS' | 'OTHER') {
    this.userService.createCompanyProfile(type).then(() => {
      this.LoadingService.stopLoad();
    });
  }
}
